import { Button } from '@/components/common/Button';
import { Heading } from '@/components/common/Heading';
import { Section } from '@/components/common/Section';
import { Footer } from '@/components/layout/Footer';
import { Header } from '@/components/layout/Header';
import { rootRoute } from '@/routes/rootRoute';
import { routes } from '@/routes/routes';
import { Link, Outlet, createRoute, useLocation } from '@tanstack/react-router';
import { ContactsPage } from './ContactsPage';
import { GettingStartedPage } from './GettingStartedPage';
import { HelpPage } from './HelpPage';
import { SafetyPrivacyPage } from './SafetyPrivacyPage';
import { ShippingPage } from './ShippingPage';
import { SupplementsRefillsPage } from './SupplementsRefillsPage';

export const HelpLayout = () => {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col">
      <Header />

      <main>
        <Outlet />

        {location.pathname !== routes.help.contactUs && (
          <Section
            containerClassName="pt-4 lg:pt-10"
            className="flex max-w-254 flex-col items-center gap-7.5 text-center"
          >
            <Heading as="h1" className="text-secondary">
              Still have questions?
            </Heading>

            <p className="max-w-125">
              We're always happy to help. Our support team is available 8am-10pm
              BST weekdays and 10am-8pm BST on weekends
            </p>

            <Button asChild>
              <Link to={routes.help.contactUs}>Contact us</Link>
            </Button>
          </Section>
        )}
      </main>

      <Footer />
    </div>
  );
};

export const helpLayoutRoute = createRoute({
  id: 'help-layout',
  getParentRoute: () => rootRoute,
  component: HelpLayout,
});

export const helpRoute = createRoute({
  getParentRoute: () => helpLayoutRoute,
  path: routes.help.index,
  component: HelpPage,
});

export const gettingStartedRoute = createRoute({
  getParentRoute: () => helpLayoutRoute,
  path: routes.help.gettingStarted,
  component: GettingStartedPage,
});

export const shippingRoute = createRoute({
  getParentRoute: () => helpLayoutRoute,
  path: routes.help.shipping,
  component: ShippingPage,
});

export const safetyPrivacyRoute = createRoute({
  getParentRoute: () => helpLayoutRoute,
  path: routes.help.safetyPrivacy,
  component: SafetyPrivacyPage,
});

export const supplementsRefillsRoute = createRoute({
  getParentRoute: () => helpLayoutRoute,
  path: routes.help.supplementsRefills,
  component: SupplementsRefillsPage,
});

export const contactsRoute = createRoute({
  getParentRoute: () => helpLayoutRoute,
  path: routes.help.contactUs,
  component: ContactsPage,
});

export const helpRoutes = helpLayoutRoute.addChildren([
  helpRoute,
  gettingStartedRoute,
  shippingRoute,
  safetyPrivacyRoute,
  supplementsRefillsRoute,
  contactsRoute,
]);
